import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

import styled from 'styled-components';

// IMPORT FUNCTIONS
import getUrl from  "../../utils/functions/getUrl";
import PostDataComplex from '../../services/PostDataComplex';
import PostData from '../../services/PostData';


const ForgotPassword = () => {

  const BASE_URL = getUrl();
  console.log(`BASE_URL: ${BASE_URL}`);

  const [message, setMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  
  const [formData, setFormData] = useState({ 
      email: "",
    }
  )

  function handleChange(event) {
    const { name, value, type, checked } = event.target
    setFormData(prevState => {
      return{
        ...prevState,
        // [event.target.name]: event.target.value
        [name]: type === "checkbox" ? checked : value
      }
    });
  };

  const handleForgotPassword  = (e) => {
    console.log('handleForgotPassword()');

    e.preventDefault();

    console.log('user data:->');
    console.log(formData);

    const localHost = String(window.location).split('/')[2].includes('localhost');
    const network = String(window.location).split('/')[2].includes('10.0.0.6');
    console.log(`localHost: ${localHost}`);
    console.log(`network: ${network}`);

    setMessage('');
    setErrorMessage('');
    
    if( localHost || network) {
      console.log('LOCALE!!!')

      if(true) {
        console.log('reset link email sent succesfully!!!');
          setMessage(`A reset link is been sent to the email you entered. 
          Please, check your email.`);
      } else {
        console.log('forgotPasswordData error!!!');
          console.log('success inserting tokens and data');
          setErrorMessage('error inserting tokens or data');
      }
      

    } else {

      // PostData('POST', 'forgotPassword', formData)
      PostDataComplex('users_manager', 'POST', 'forgotPassword', formData)
        .then((response) => {
          console.log('response.data:->');
          console.log(response.data);

          const forgotPasswordResult = response.data.feedBack.forgotPasswordData.forgotPasswordResult;

          if(forgotPasswordResult.forgotpwddatastoring) {
            if(forgotPasswordResult.forgotpwddatastoring.emailSent)  {
              console.log('reset link email sent succesfully!!!');
              setMessage('A reset link is been sent to the email you entered. \n Please, check your email.');
            }
          } else {
            console.log('forgotPasswordData error!!!');
            console.log(forgotPasswordResult);
            setErrorMessage(forgotPasswordResult);
          }
        }
      )

    }

  }

  return (
    <Wrapper id="forgor-password--wrapper">
      {/* <Header>Forgot Password</Header> */}
      <Container id="forgor-password--container">
        <Content>
          <ContentHeader>
            PictureViewer
            <span>by rndWs.com</span>
          </ContentHeader>
          <Title>
            Forgot password?
            <span>Don't worry, a piece of cake.</span>
          </Title>
          <Form>
            
            <Input 
              placeholder="Email (i)"
              id="email"
              type="email"
              value={formData.email}
              onChange={handleChange}
              name="email"
            />
            <Button onClick={handleForgotPassword}>Send reset link</Button>
            {message &&<Message>{message}</Message>}
            {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
          </Form>
          <ButtonBelly>
            <span><Link to={BASE_URL +"/login"}>Back to login</Link></span>
          </ButtonBelly>
          
        </Content>
      </Container>
    </Wrapper>
  )
}

export default ForgotPassword;

const Wrapper = styled.div `
  width: 100%;
  height: 10vh;
  color: #d1d1d1;
  background-color: transparent;
  font-size:2rem;
  /* padding: 10px 30px; */
  min-height: 90vh;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const Header = styled.div `
  /* text-align: center; */
`;

const Container = styled.div `
  /* width: 400px; */
`;
const Content = styled.div `
  border: 1px solid orange;
  padding-bottom: 2rem;
  background-color: rgba(0,0,0,0.4);
`;
const ContentHeader = styled.div `
  display: flex;
  flex-direction: column;

  text-align: center;
  background-color: #111;
  padding: 2rem 3rem;
  line-height: 1.3rem;

  span {
    font-size: 1rem;
  }
`;
const Title = styled.div `
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  font-size: 1.6rem;
  padding: 1rem 2.4rem;

  span {
    font-size: 1rem;

    a {
      color: #3e85f5;
    }
  }

`;

const Form = styled.form `
  display: flex;
  flex-direction: column;
  
  padding: 1rem .5rem;

`;
const Input = styled.input `
  border: 1px solid #1b1b1b;
  background-color: #0e0e0e;
  font-size: 1.1rem;
  margin-top: .2rem;
  padding: 1rem .8rem;
  color: #d1d1d1;

`;
const Button = styled.button `
  color: #fff;
  border: 1px solid #1b1b1b;
  background-color: #029F85;
  border-radius: 5px;;
  font-size: 1rem;
  padding: 1rem .8rem;
  margin-top: .4rem;

  cursor: pointer;
`;

const Message = styled.div `
  font-size: 1rem;
  padding: 1rem .8rem;
  text-align: center;
  height: 1rem;
  color: green;
  /* border: 1px solid orange; */
  
`;
const ErrorMessage = styled.div `
  font-size: 1rem;
  padding: 1rem .8rem;
  text-align: center;
  height: 1rem;
  color: red;
  /* border: 1px solid orange; */
  
`;

const ButtonBelly = styled.div `
  font-size: 1rem;
  padding: 1rem .8rem;
  text-align: center;

  span {
    font-size: 1rem;
    color: #029F85;
  }
`;
